module.exports = __webpack_public_path__ + "img/Group 1029six.8d184140.png";